import React from 'react'
import { connect } from 'react-redux'
import { Card, Tabs, Row, Col, Radio } from 'antd'

import Logo from 'assets/images/now-by-ekko.png'

import NowInstallWordPress from 'components/Products/NowInstallWordPress'
import NowInstallCustom from 'components/Products/NowInstallCustom'

const { TabPane } = Tabs

class Installation extends React.Component {
    render() {
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
        };
        return (
            <Card title={false}>
                <Row>
                    <Col xs={24} sm={8} md={6} style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                        <img src={Logo} height={48} />
                    </Col>
                    <Col xs={24} sm={16} md={18} style={{ marginTop: 10, display: 'flex', alignItems: 'center' }}>
                        <h3>Designed for product managers, Now is a Ready-to-use plugin to add chat on websites.</h3>
                    </Col>
                </Row>

                <h4 style={{ marginLeft: 30, marginTop: 50, marginBottom: 20 }}>Install Now on your Website :</h4>

                <Tabs defaultActiveKey="wordpress" style={{ marginLeft: 30, marginBottom: 30 }}>
                    <TabPane tab="WordPress Website" key="wordpress">
                        <NowInstallWordPress />
                    </TabPane>
                    <TabPane tab="Custom Website" key="custom">
                        <NowInstallCustom />
                    </TabPane>
                </Tabs>
            </Card>
        )
    }
}

const mapStateToProps = ({ekko}) => ({
    currentApp: ekko.currentApp
})

const mapActionsToProps = dispatch => ({
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(Installation)
